module.exports = __webpack_public_path__ + "static/media/score_sound.41950e82.mp3";